import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import VirtualTour360 from './components/VirtualTour360';
import AddDestination from './components/Admin/AddDestination';

// Translation resources
const resources = {
  en: {
    translation: {
      destinations:"Explore our region",
      planYourTrip:"Plan your trip",
      events:"Events",
      calendar:"Cultural Calendar",
      aboutPieria:"About Olympus Riviera",
      accommodation:"Accommodation",
      registerSignIn:"Register / Sign in",
      visitors:"Visitors",
      businesses:"Businesses",
      pointsOfInterest:"Points of Interest",
      population:"Population",
      interactiveMap:"Interactive Map",
      interactiveMapDescription:"Explore the authentic side of Olympus Riviera through our interactive map!",
      popularDestinations:"Popular Destinations",
      instagramFeed:"Instagram feed",
      hashtag:"#OLYMPUSRIVIERA",
      loadMore:"Load more",
      weather:"Weather",
      downloadMobileApp: "Download our mobile app",
      downloadOn: "DOWNLOAD ON",
      googlePlay:"Google Play",
      copyrightText:"2024 Pieria Regional Unit",
      olympusRiviera:"OLYMPUS RIVIERA",
      about:"ABOUT",
      termsOfUse:"Terms of Use",
      privacyPolicy:"Privacy Policy",
      contact:"Contact",
      followUs:"Follow us",
      discoverMore:"Discover More",
      // downloadTextDescr: " Download our mobile application for mobile phone , to have a unique travel experience in Pieria Greece!", //TODO
      downloadTextDescr: "Available soon!", //TODO
      weatherDescription:"Check out the weather of the week and make a trip plan that suits you best!",
      homeImageText:"Discover amazing destinations and experiences",
      welcomeToOR:"Welcome to Olympus Riviera",
      createAccount:"Create Account",
      register:"Register",
      signIn:"Sign In",
      forgotPassword:"Forgot your password?",
      registerDescription:"Create your account and start a unique journey.",
      welcomeBack:"Welcome back!",
      signInDescription:"Keep connected to discover more about Olympus Riviera.",
      visitor:"Visitor",
      business:"Buisiness",
      back:"Back",
      experiences:"Experiences",
      history:"History",
      activities:"Activities",
      winter:"Winter",
      summer:"Summer",
      autumn:"Autumn",
      spring:"Spring",
      manageProfile:"Manage Profile",
      signOut:"Sign Out",
      manageBusinesses:"Manage businesses",
      registerNewBusiness:"Register a New Business",
      businessName:"Business Name",
      phone:"Telephone",
      email:"E-mail",
      longitude:"Longitude",
      latitude:"Latitude",
      description:"Description",
      category:"Category",
      businessOwner:"Business Owner",
      photos:"Photographs",
      documents:"Documents",
      sendRegistrationReq:"Registration Request",
      type:"Type",
      status:"Status",
      adminComments:"Admin Comments",
      submitEdit:"Submit Changes",
      cancel:"Cancel",
      deleteReq:"Delete Request",
      edit:"Edit",
      manageEvents:"Manage Events",
      eventName:"Event Name",
      link:"Link",
      startDate:"Start Date",
      endDate:"End Date",
      fullname:"Full Name",
      profileInfo:"Profile Information",
      requests:"Requests",
      newEvent:"Create a New Event",
      deleteyourAccount:"Are you sure you want to delete your account?",
      deleteAccount:"Delete Account",
      delete:"Delete",
      preferences:"Preferences",
      discoverDestinations:"Discover the unique destinations of Olympus Riviera.",
      startChooseCategory:" Start by choosing a category!",
      selectFavPreferences:"Pick your favorites and let's start exploring!",
      destinationsCategories:"Destination Categories",
      amenitiesCategories:"Amenity Categories",
      experiencesCategories:"Experience Categories",
      clear:"Clear",
      apply:"Apply",
      panoramicView:"Panoramic View",
      virtualTour360: "360 Virtual Tour",
      close:"Close",
      providerName:"Provider Name",
      location:"Location",
      amenities:"Amenities",
      favoritesList:"Favorites List",
      favorites:"Favorites",
      alreadyLoggedIn:"You are already signed in! Do you want to sign out?",
      registerAs:"Register as:",
      selectUserType:"*Please select a user type to proceed.",
      updatePreferences:"Update Preferences",
      loading:"Loading...",
      virtualTour360Description:"Take a closer look to the destination through a 360 virtual tour!",
      panoramicViewDescription:"Enjoy the magnificent scenery from above, because panoramic view is always a better idea!",
      testimonies:"Testimonies",
      testimoniesDescription:"Read the testimonials of other visitors and don't hesitate to leave your own review!",
      testimonySignInMessage:"You need to sign in to submit a testimonial.",
      submit:"Submit",
      shareYourExperience:"Share your experience",
      yourTestimonial:"Your testimonial",
      suggestions:"Suggestions",
      newsTitle:"Local events",
      eventsDescription:"Stay informed about Pieria events and find useful information.",
      deletion:"Delete",
      logInLink:"Sign in",
      loginMessage:"to register a new event.",
      eventDetails:"Event Details",
      selectPointsVisited:"Select the points you have already visited!",
      pointsVisited:"Poits visited",
      experiencePath:"Experience path",
      experiencePathDescription:"Follow the path of this unique experience and discover new locations!",
      tripPlan:"Trip plan",
      title:"Title",
      points:"Points",
      search:"Search",
      noResultsFound:"No results found.",
      save:"Save",
      newPlan:"New plan",
      savedPlans:"Saved plans",
      noPlansAvailable:"No plans available.",
      editPlan:"Edit plan",
      update:"Update",
      selectCategory:"Select a category",
      viewToMap:"View to map",
      signin_with: "Sign-in with",
      downloadTourGuide:"You can download our tour guide for free and begin to explore Pieria!",
      downloadHere:"Download here",
      registeredUsers:"Registered users",
      providers:"Providers",
      adminUsersDesc:"View and manage user accounts",
      adminProvidersDesc:"Handle provider details",
      adminDestinationsDesc:"Edit,manage,delete destinations",
      adminExperiencesDesc:"Edit,manage,delete experiences",
      adminEventsDesc:"Edit,manage,delete events",
      adminAmenitiesDesc:"Update available amenities",
      adminRequestsDesc:"Handle user requests or complaints",
      adminDashboard:"Admin Dashboard",
      adminDashDescr:"Welcome! Select a section to manage:",
      searchUserText:"Search by name or email...",
      manageRegisteredUsers:"Manage Users",
      searchProviderText:"Search by name or email",
      manageProviders:"Manage providers",
      manageDestinations:"Manage destinations",
      name: "Name",
      actions:"Actions",
      addDestination:"Add destination",
      backToDestinations:"Back to Destinations",
      searchByName:"Search by name",
      coverPhoto:"Cover photo",
      editDestination:"Edit destination",
      manageExperiences:"Manage experiences",
      addExperience:"Add experience",
      editExperience:"Edit experience",
      backToExperiences:"Back to experiences",
      backToEvents:"Back to events",
      editEvent:"Edit event",
      addEvent:"Add event",
      pleaseConfirm:"Please confirm to proceed with admin login.",
      areUadmin:"Are you the admin?",
      yes:"Yes",
      signInAsAdmin:"Sign in as Admin",
      categoryPhoto:"Category photo",
      galleryPhotos:"Gallery photos",
      noFiles:"No files. Please edit and upload!",
      loading:"Loading...",
      posterPhoto:"Event poster",
      backToAmenities:"Back to amenities",
      editAmenity:"Edit amenity",
      manageAmenities:"Manage amenities",
      addAmenity:"Add amenity",
      adminAboutPieriaInfo:"View and edit the about Pieria inforamation that the users see on the site",
      approve:"Approve",
      noPendingProviderRequests:"",
      details:"Details",
      files:"Files",
      providerRequests:"Provider Requests",
      amenityRequests:"Amenity Requests",
      eventRequests:"Event Requests",
      manageRequests:"Manage Requests",
      addCommentForRevision:"Add Comment for Revision",
      writeCommentHere:"Write your comment here...",
      submitCommentRequestRevision:"Submit Comment & Request Revision",
      confirmDeactivateProvider:"Do you want to deactivate the provider profile?",
      confirmDeactivateUser:"Are you sure you want to deactivate this user?",
      selectProvider:"Select Provider",
      eventAddedSuccessfully:"Event Added Successfully",
      eventUpdatedSuccessfully:"Event Updated Successfully",
      confirmDelete:"Confirm delete?",
      updatedSuccessfully:"Updated successfully!",
      reject:"Reject",
      adminAllCategoriesDescr:"Manage all categories.",
      allCategories:"All categories",
      backToCategories:"Back to categories",
      addCategory:"Add category",
      eventCategory:"event category",
      destinationCategory:"destination category",
      amenityCategory:"amenity category",
      experienceCategory:"experience category",
      eventCategories:"Event categories",
      destinationCategories:"Destination categories",
      amenityCategories:"Amenity categories",
      experienceCategories:"Experience categories",
      add:"Add",
      elevationChart:"Elevation chart",
      hide:"Hide",
      view:"View",
      completeProviderRegistration:"Complete provider registration",
      requiredActions:"Required actions",
      uploadPDF:"Upload your PDF documents",
      accessibilityPoints: "Accessible Tourism",
      bookNow:"Live the experience",
      haveVisited:"Have visited",
      addToFavorites:"Add to favorites",
      personalizedRecommendations:"Based on your preferences we suggest:",
      similarRecommendations:"Similar profiles searched for:",
      adminComment:"Admin Comment",
      noPendingEventRequests:"No pending event requests.",
      noPendingAmenityRequests:"No pending amenity requests.",
      addPreferencesToProfile:"Add destination and experience preferences to your profile to get personalised recommendations!",
      video:"Video",
      videoLink:"Video link",
      success:"Success!",
      forRevision:"For revision",
      pending:"Pending",
      noRequests:"No requests.",
      search:"Search...",
      description:"Description",
      statistic:"Statistic",
      label:"label",
      number:"number",
      noEventsFound:"No events found for the next 30 days.",
      address:"Address",
      cookiePolicy:"Cookies Policy",
      agiosPavlosTitle:"Steps of the Apostle Paul in Pieria",
      docLib:"Touristic Guides",
      english:"English",
      greek:"Greek",
      cannotEditPendingRequest:"Cannot edit right now, you already have pending requests for this amenity.",
      errorUpdatingAmenity: "Failed to update Amenity.",
      websiteUrl: "Website URL"

       
    },
  },
  gr: {
    translation: {
        destinations:"Εξερευνήστε τον τόπο μας",
        planYourTrip:"Οργάνωσε το ταξίδι σου",
        events:"Εκδηλώσεις",
        calendar:"Πολιτιστικό Καλεντάρι",
        aboutPieria:"Σχετικά με την Πιερία",
        accommodation:"Διαμονή",
        registerSignIn:"Εγγραφή / Σύνδεση",
        visitors:"Επισκέπτες",
        businesses:"Επιχειρήσεις",
        pointsOfInterest:"Σημεία Ενδιαφέροντος",
        population:"Πληθυσμός",
        interactiveMap:"Διαδραστικός Χάρτης",
        interactiveMapDescription:"Εξερευνήστε την αυθεντική πλευρά της Πιερίας μέσα από τον διαδραστικό μας χάρτη!",
        popularDestinations:"Δημοφιλείς προορισμοί",
        instagramFeed:"Instagram feed",
        hashtag:"#OLYMPUSRIVIERA",
        loadMore:"Περισσότερα",
        weather:"Καιρός",
        downloadMobileApp: "Κατεβάστε την εφαρμογή μας για κινητά",
        downloadOn:"ΑΠΟΚΤΗΣΕ ΤΟ ΣΤΟ",
        googlePlay:"Google Play",
        copyrightText:"2024 Νομός Πιερίας",
        olympusRiviera:"OLYMPUS RIVIERA",
        about:"ΣΧΕΤΙΚΑ",
        termsOfUse:"Όροι Χρήσης",
        privacyPolicy:"Πολιτική Απορρήτου",
        contact:"Επικοινωνία",
        followUs:"Ακολουθήστε μας",
        discoverMore:"Ανακαλύψτε περισσότερα",
        // downloadTextDescr: "Κατεβάστε την εφαρμογή για κινητά τηλέφωνα, για να έχετε μια μοναδική ταξιδιωτική εμπειρία στην Πιερία!", //TODO
        downloadTextDescr: "Σύντομα διαθέσιμη!", //TODO
        weatherDescription:"Δείτε τον καιρό της εβδομάδας και σχεδιάστε το πλάνο ταξιδιού που σας ταιριάζει καλύτερα!",
        homeImageText:"Ανακαλύψτε εκπληκτικούς προορισμούς και εμπειρίες",
        welcomeToOR:"Καλώς ήρθατε στο Olympus Riviera",
        createAccount:"Δημιουργία Λογαριασμού",
        signIn:"Σύνδεση",
        forgotPassword:"Ξέχασες τον κωδικό σου;",
        registerDescription:"Δημιουργήστε τον λογαριασμό σας και ξεκινήστε ένα μοναδικό ταξίδι.",
        welcomeBack:"Καλωσόρισες ξανά!",
        signInDescription:"Παραμείνετε συνδεδεμένοι για να ανακαλύψετε περισσότερα για την Πιερία.",
        register:"Εγγραφή",
        visitor:"Επισκέπτης",
        business:"Επιχείρηση",
        back:"Πίσω",
        experiences:"Εμπειρίες",
        history:"Ιστορία",
        activities:"Δραστηριότητες",
        winter:"Χειμώνας",
        summer:"Καλοκαίρι",
        autumn:"Φθινόπωρο",
        spring:"Άνοιξη",
        manageProfile:"Διαχείριση Προφίλ",
        signOut:"Αποσύνδεση",
        manageBusinesses:"Διαχείριση Επιχειρήσεων",
        registerNewBusiness:"Καταχώριση Επιχείρησης",
        businessName:"Επωνυμία Επιχείρησης",
        phone:"Τηλέφωνο",
        email:"E-mail",
        longitude:"Γεωγραφικό μήκος",
        latitude:"Γεωγραφικό πλάτος",
        description:"Περιγραφή",
        category:"Κατηγορία",
        businessOwner:"Ιδιοκτήτης Επιχείρησης",
        photos:"Φωτογραφίες",
        documents:"Έγγραφα",
        sendRegistrationReq:"Αίτημα καταχώρησης",
        type:"Τύπος",
        status:"Κατάσταση",
        adminComments:"Σχόλια Διαχειριστή",
        submitEdit:"Υποβολή Αλλαγών",
        cancel:"Ακύρωση",
        deleteReq:"Διαγραφή Αιτήματος",
        edit:"Επεξεργασία",
        manageEvents:"Διαχείριση Εκδηλώσεων",
        eventName:"Όνομα Εκδήλωσης",
        link:"Σύνδεσμος",
        startDate:"Ημερομηνία Έναρξης",
        endDate:"Ημερομηνία Λήξης",
        fullname:"Ονοματεπώνυμο",
        profileInfo:"Πληροφορίες Προφίλ",
        requests:"Αιτήματα",
        newEvent:"Δημιουργία Νέας Εκδήλωσης",
        deleteyourAccount:"Θέλετε σίγουρα να διαγραφεί ο λογαριασμός σας;",
        deleteAccount:"Διαγραφή Λογαριασμού",
        delete:"Διαγραφή",
        preferences:"Προτιμήσεις",
        discoverDestinations:"Ανακαλύψτε τους μοναδικούς προορισμούς της Πιερίας.",
        startChooseCategory:"Ξεκινήστε επιλέγοντας κατηγορία!",
        selectFavPreferences:"Διαλέξτε τα αγαπημένα σας και ας ξεκινήσουμε την εξερεύνηση!",
        destinationsCategories:"Κατηγορίες Προορισμών",
        amenitiesCategories:"Κατηγορίες Επιχειρήσεων",
        experiencesCategories: "Κατηγορίες Εμπειριών",
        clear:"Καθαρισμός",
        apply:"Εφαρμογή",
        panoramicView:"Πανοραμική Θέα",
        virtualTour360: "360 Εικονική Περιήγηση",
        close:"Κλείσιμο",
        providerName:"Όνομα Παρόχου",
        location:"Τοποθεσία",
        amenities:"Παροχές",
        favoritesList:"Λίστα Αγαπημένων",
        favorites:"Αγαπημένα",
        alreadyLoggedIn:"Είστε ήδη συνδεδεμένος! Θέλετε να αποσυνδεθείτε;",
        registerAs:"Εγγραφή ως:",
        selectUserType:"*Επιλέξτε έναν τύπο χρήστη για να συνεχίσετε.",
        updatePreferences:"Ενημέρωση Προτιμήσεων",
        loading:"Φόρτωση...",
        virtualTour360Description:"Ρίξτε μια πιο προσεκτική ματιά στον προορισμό μέσω μιας εικονικής περιήγησης 360°!",
        panoramicViewDescription:"Απολαύστε το μαγευτικό τοπίο από ψηλά, αφού η πανοραμική θέα είναι πάντα καλύτερη ιδέα!",
        testimonies:"Μαρτυρίες",
        testimoniesDescription:"Διαβάστε τις μαρτυρίες άλλων επισκεπτών και μην διστάσετε να αφήσετε μια δική σας αξιολόγηση!",
        testimonySignInMessage:"Πρέπει να συνδεθείτε για να υποβάλετε μια μαρτυρία.",
        submit:"Υποβολή",
        shareYourExperience:"Μοιραστείτε την εμπειρία σας",
        yourTestimonial:"Η μαρτυρία σας",
        suggestions:"Προτάσεις",
        newsTitle:"Οι εκδηλώσεις του τόπου",
       eventsDescription:"Ενημερωθείτε για τις εκδηλώσεις της Πιερίας και βρείτε χρήσιμες πληροφορίες.",
       deletion:"Διαγραφή",
       logInLink:"Συνδεθείτε",
       loginMessage:"για να καταχωρήσετε μια νέα εκδήλωση.",
       eventDetails:"Πληροφορίες Εκδήλωσης",
       selectPointsVisited:"Επιλέξτε τα σημεία που έχετε ήδη επισκεφτεί!",
       pointsVisited:"",
       experiencePath:"Διαδρομή εμπειρίας",
       experiencePathDescription:"Ακολουθήστε την διαδρομή αυτής της μοναδικής  εμπειρίας και ανακαλύψτε νέες τοποθεσίες!",
       tripPlan:"Πλάνο ταξιδιού",
       title:"Τίτλος",
       points:"Σημεία",
       search:"Αναζήτηση",
       noResultsFound:"Δεν βρέθηκαν αποτελέσματα.",
       save:"Αποθήκευση",
       newPlan:"Νέο πλάνο",
       savedPlans:"Αποθηκευμένα πλάνα",
       noPlansAvailable:"Δεν υπάρχουν διαθέσιμα πλάνα",
       editPlan:"Επεξεργασία πλάνου",
       update:"Ενημέρωση",
       selectCategory:"Επιλέξτε μια κατηγορία",
       viewToMap:"Προβολή στον χάρτη",
       signin_with: "Σύνδεση μέσω",
       downloadTourGuide:"Μπορείτε να κατεβάσετε τον ξεναγό μας δωρεάν και να ξεκινήσετε την εξερεύνηση της Πιερίας!",
       downloadHere:"Κατεβάστε εδώ",
       registeredUsers:"Εγγεγραμένοι χρήστες",
       providers:"Πάροχοι",
       adminUsersDesc:"Προβολή και διαχείριση λογαριασμών χρηστών",
       adminProvidersDesc:"Προβολή και διαχείριση λογαριασμών παρόχων",
       adminDestinationsDesc:"Επεξεργασία, διαχείριση, διαγραφή προορισμών",
       adminExperiencesDesc:"Επεξεργασία, διαχείριση, διαγραφή εμπειριών ",
       adminEventsDesc:"Επεξεργασία, διαχείριση, διαγραφή εκδηλώσεων ",
       adminAmenitiesDesc:"Επεξεργασία, διαχείριση, διαγραφή επιχειρήσεων ",
       adminRequestsDesc:"Διαχείριση αιτημάτων χρηστών ",
       adminDashboard:"Πίνακας ελέγχου διαχειριστή",
       adminDashDescr:"Καλώς ορίσατε! Επιλέξτε μια ενότητα για διαχείριση:",
       searchUserText:"Αναζήτηση με όνομα ή email...",
       manageRegisteredUsers:"Διαχείριση χρηστών",
       searchProviderText:"Αναζήτηση με όνομα ή email",
       manageProviders:"Διαχείριση παρόχων",
       manageDestinations:"Διαχείριση προορισμών",
       name: "Όνομα",
       actions:"Ενέργειες",
       addDestination:"Προσθήκη προορισμού",
       backToDestinations:"Πίσω στους προορισμούς",
       searchByName:"Αναζήτηση με όνομα",
       coverPhoto:"Φωτογραφία εξωφύλλου",
       editDestination:"Επεξεργασία προορισμού",
       manageExperiences:"Διαχείριση εμπειριών",
       addExperience:"Προσθήκη εμπειρίας",
       editExperience:"Επεξεργασία εμπειρίας",
       backToExperiences:"Πίσω στις εμπειρίες",
       backToEvents:"Πίσω στις εκδηλώσεις",
       editEvent:"Επεξεργασία εκδήλωσης",
       addEvent:"Προσθήκη εκδήλωσης",
       areUadmin:"Είστε ο διαχειριστής;",
       pleaseConfirm:"Επιβεβαιώστε για να συνεχίσετε τη σύνδεση ως διαχειριστής.",
       yes:"Ναι",
       signInAsAdmin:"Σύνδεση ως διαχειριστής",
       categoryPhoto:"Φωτογραφία κατηγορίας",
       galleryPhotos:"Φωτογραφίες συλλογής",
       noFiles:"Δεν υπάρχουν αρχεία.Επεξεργαστείτε και ανεβάστε!",
       loading:"Φόρτωση...",
       posterPhoto:"Αφίσα εκδήλωσης",
       backToAmenities:"Πίσω στις παροχές ",
       editAmenity:"Επεξεργασία παροχής",
       addAmenity:"Προσθήκη παροχής",
       manageAmenities:"Διαχείριση παροχών",
       adminAboutPieriaInfo:"Δείτε και επεξεργαστείτε τις πληροφορίες σχετικά με την Πιερία που βλέπουν οι χρήστες στον ιστότοπο",
       approve:"Έγκριση",
       details:"Λεπτομέρειες",
       files:"Αρχεία",
       providerRequests:"Αιτήματα Παρόχων",
       amenityRequests:"Αιτήματα Επιχειρήσεων",
       eventRequests:"Αιτήματα Εκδηλώσεων",
       manageRequests:"Διαχείριση Αιτημάτων",
       addCommentForRevision:"Προσθήκη σχολίου για αναθεώρηση",
       writeCommentHere:"Γράψτε το σχόλιό σας εδώ...",
       submitCommentRequestRevision:"Υποβολή σχολίου και αίτημα αναθεώρησης",
       confirmDeactivateProvider:"Θέλετε να απενεργοποιήσετε το προφίλ του παρόχου;",
       confirmDeactivateUser:"Είστε σίγουροι ότι θέλετε να απενεργοποιήσετε αυτόν τον χρήστη;",
       selectProvider:"Επιλέξτε πάροχο",
       eventAddedSuccessfully:"Η εκδήλωση προστέθηκε με επιτυχία",
       eventUpdatedSuccessfully:"Η εκδήλωση ενημερώθηκε με επιτυχία",
       confirmDelete:"Επιβεβαίωση διαγραφής;",
       updatedSuccessfully:"Ενημερώθηκε με επιτυχία!",
       reject:"Απόρριψη",
       adminAllCategoriesDescr:"Διαχειριστείτε όλες τις κατηγορίες.",
       allCategories:"Όλες οι κατηγορίες",
       backToCategories:"Επιστροφή στις κατηγορίες",
       addCategory:"Προσθήκη κατηγορίας",
       eventCategory:"κατηγορίας εκδηλώσεων",
       destinationCategory:"κατηγορίας προορισμών",
       amenityCategory:"κατηγορίας παροχών",
       experienceCategory:"κατηγορίας εμπειριών",
       eventCategories:"Κατηγορίες εκδηλώσεων",
       destinationCategories:"Κατηγορίες προορισμών",
       amenityCategories:"Κατηγορίες παροχών",
       experienceCategories:"Κατηγορίες εμπειριών",
       add:"Προσθήκη",
       elevationChart:"Διάγραμμα υψομέτρου",
       hide:"Απόκρυψη",
       view:"Εμφάνιση",
       completeProviderRegistration:"Ολοκλήρωση εγγραφής παρόχου",
       requiredActions:"Απαιτούμενες ενέργειες",
       uploadPDF:"Ανεβάστε τα έγγραφά σας σε PDF μορφή",
       accessibilityPoints: "Προσβάσιμος Τουρισμός",
       bookNow:"Ζήσε την Εμπειρία",
       haveVisited:"Έχω επισκεφτεί",
       addToFavorites:"Προσθήκη στα αγαπημένα",
       personalizedRecommendations:"Με βάση τις προτιμήσεις σας, προτείνουμε:",
       similarRecommendations:"Παρόμοια προφίλ αναζήτησαν:",
       adminComment:"Σχόλιo διαχειριστή",
       noPendingProviderRequests:"Δεν υπάρχουν εκκρεμή αιτήματα παρόχων.",
       noPendingEventRequests:"Δεν υπάρχουν εκκρεμή αιτήματα για εκδηλώσεις.",
       noPendingAmenityRequests:"Δεν υπάρχουν εκκρεμή αιτήματα για παροχές.",
       addPreferencesToProfile:"Προσθέστε προτιμήσεις προορισμού και εμπειρίας στο προφίλ σας για να λαμβάνετε εξατομικευμένες προτάσεις!",
       video:"Βίντεο",
       videoLink:"Σύνδεσμος βίντεο",
       success:"Επιτυχία!",
       forRevision:"Για αναθεώρηση",
       pending:"Σε εκκρεμότητα",
       noRequests:"Δεν υπάρχουν αιτήματα.",
       search: "Αναζήτηση...",
       description:"Περιγραφή",
       statistic:"Στατιστικό",
       label:"κείμενο",
       number:"νούμερο",
       noEventsFound:"Δεν βρέθηκαν εκδηλώσεις για τις επόμενες 30 ημέρες.",
       address:"Διεύθυνση",
       cookiePolicy:"Πολιτική Cookies",
       agiosPavlosTitle:"Βήματα του Αποστόλου Παύλου στην Πιερία",
       docLib:"Τουριστικοί Οδηγοί",
       english:"Aγγλικά",
       greek:"Ελληνικά",
       cannotEditPendingRequest:"Δεν είναι δυνατή η επεξεργασία αυτήν τη στιγμή, έχετε ήδη εκκρεμή αιτήματα για αυτήν την καταχώρηση.",
       errorUpdatingAmenity: "Αποτυχία ενημέρωσης.",
       websiteUrl: "Διεύθυνση Ιστοσελίδας"
      
      },
  },
};

i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    // lng: "en", // default language
    lng: sessionStorage.getItem('selectedLanguage') || 'en',
    fallbackLng: "en", // fallback language
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;

